import Test from '../view/systemManage/test/test'
import testTabel from '../view/systemManage/test/content/index'
import testForm from '../view/systemManage/test/content/form'

const test = {
    path: '/test',
    component: Test,
    redirect: '/test/tabel',
    children: [
        {
            path: '/test/tabel',
            name: 'test-tabel',
            component: testTabel,
            meta: {
                title: '测试表格'
            }
        },{
            path: '/test/form',
            name: 'test-form',
            component: testForm,
            meta: {
                title: '测试表单'
            }
        },
    ]
}

export default test
